// Shared, app-wide constants. Mirrors the `constants.ts` convention from
// stratum-analytical (adapted to plain JS / CRA env vars).

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

export const LOCATION_META = {
  toronto:    { name: 'Shangri-La',     color: '#c9956a' },
  foresthill: { name: 'Forest Hill', color: '#6db88a' },
  vancouver:  { name: 'Hyatt Alberni',   color: '#7a9ec9' },
  waterfront: { name: 'VIP Waterfront',  color: '#aa6030' },
};

export const STATUS_CYCLE   = { available: 'busy', busy: 'break', break: 'available' };
export const STATUS_LABEL   = { available: 'AVAILABLE', busy: 'BUSY', break: 'BREAK' };
export const PRIORITY_CYCLE  = { low: 'medium', medium: 'high', high: 'urgent', urgent: 'low' };
export const PRIORITY_LABEL  = { low: 'LOW', medium: 'MEDIUM', high: 'HIGH', urgent: 'URGENT' };

// TODO: Cash and Square Terminal need the amount field
// TODO: if amount higher than service amount on the card, that will be tip after amount + tax.
// For example in toronto service is $100, the amount is $120, then $113, $7 is tip
export const PAYMENT_METHODS = ['Cash', 'Square Terminal', 'Invoice'];

export const NEXT_STEP_META = {
  started:  { title: 'Start Appointment',  prompt: 'Do you want to start this appointment?', requiredPhotos: 3, phase: 'before', confirmLabel: 'Start' },
  finished: { title: 'Finish Appointment', prompt: 'Is this appointment finished?',          requiredPhotos: 3, phase: 'after',  confirmLabel: 'Finish' },
  upsells:  { title: 'Upsells',            prompt: 'Are there any upsells?',                  requiredPhotos: 0, phase: 'photo',  confirmLabel: 'Confirm' },
  payment:  { title: 'Payment',            prompt: 'Has payment been collected?',             requiredPhotos: 0, phase: 'photo',  confirmLabel: 'Confirm' },
  posted:   { title: 'Posted',             prompt: 'Mark this appointment as posted?',        requiredPhotos: 0, phase: 'photo',  confirmLabel: 'Confirm' },
};

export const ROLE_LABELS = {
  staff: 'Staff',
  admin: 'Admin',
  share_device: 'Shared Device',
};

// Roles restricted to the shared-device view — a wall display in the bay, which
// sees only what is safe to leave on screen in public. Named for the role
// rather than for what it can currently reach, since the permitted surface will
// grow. Kept here so both the router and the pages can read it without
// importing each other.
export const SHARE_DEVICE_ONLY_ROLES = ['share_device'];
export const isShareDeviceOnly = (user) => SHARE_DEVICE_ONLY_ROLES.includes(user?.role);
